import styled from 'styled-components'
import {Heading} from 'grommet'

const StyledHeading = styled(Heading)`
  font-weight: ${props =>
    props.weight ? props.weight : props.theme.heading.weight};
`
export default StyledHeading
